/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'company-hub.links-menu-extension.alignment.title': 'Alignement',
  'company-hub.links-menu-extension.all.borders.label-text': 'Tous les côtés',
  'company-hub.links-menu-extension.background.color': "Couleur d'arrière-plan",
  'company-hub.links-menu-extension.background.title': 'Arrière-plan',
  'company-hub.links-menu-extension.border.color': 'Couleur de la bordure',
  'company-hub.links-menu-extension.border.position': 'Position de la bordure',
  'company-hub.links-menu-extension.bottom.border.label-text': 'Bordure inférieure',
  'company-hub.links-menu-extension.center.option': 'Centre',
  'company-hub.links-menu-extension.config-panel.add-link-button.description': 'Ajouter des liens importants',
  'company-hub.links-menu-extension.config-panel.add-link-button.text': 'Lien',
  'company-hub.links-menu-extension.config-panel.add-menu-button.description': 'Regrouper les liens connexes',
  'company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text':
    'Vous avez atteint le nombre maximal de niveaux imbriqués.',
  'company-hub.links-menu-extension.config-panel.add-menu-button.text': 'Menu',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text': 'Annuler',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text': 'Supprimer',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text':
    'Cette action supprimera cet élément ainsi que tous les éléments imbriqués.',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text': "Supprimer l'élément",
  'company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text': 'Ajouter un sous-élément',
  'company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text': "Supprimer l'élément",
  'company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text': 'Modifier les propriétés',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text': 'Déplacer vers le bas',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text': 'Déplacer vers le haut',
  'company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text': 'Ouvrir le lien',
  'company-hub.links-menu-extension.config-panel.items.label': 'Éléments',
  'company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text':
    "Vous avez atteint le nombre maximal d'éléments pouvant être ajoutés au menu des liens.",
  'company-hub.links-menu-extension.config-panel.new-item-button.text': 'Nouvel élément',
  'company-hub.links-menu-extension.config-panel.preamble':
    'Ajoutez des liens et organisez-les avec des sous-menus. {linksMenuSupportLink}',
  'company-hub.links-menu-extension.config-panel.preamble-link.label': 'En savoir plus sur le menu des liens',
  'company-hub.links-menu-extension.config-panel.preamble-without-support-link':
    'Ajoutez des liens et organisez-les avec des sous-menus.',
  'company-hub.links-menu-extension.config-panel.property-config.cancel-button-label': 'Annuler',
  'company-hub.links-menu-extension.config-panel.property-config.confirm-button-label': 'Confirmer',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-error': 'Veuillez renseigner ce champ.',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-label': "Texte d'affichage",
  'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder': "Nom de l'élément",
  'company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label': 'Confirmer',
  'company-hub.links-menu-extension.config-panel.property-config.more-button-label': 'Plus',
  'company-hub.links-menu-extension.config-panel.styles.label': 'Styles',
  'company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text':
    "Vous avez atteint le nombre maximal d'éléments pouvant être ajoutés au menu des liens.",
  'company-hub.links-menu-extension.config-panel.title': 'Menu des liens',
  'company-hub.links-menu-extension.fixed.option': 'Fixée en haut',
  'company-hub.links-menu-extension.left.option': 'À gauche',
  'company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title': 'Plus',
  'company-hub.links-menu-extension.manifest.extension-description':
    "Ajouter plusieurs liens et sous-menus au hub d'entreprise",
  'company-hub.links-menu-extension.manifest.extension-lozenge-title': 'Menu des liens',
  'company-hub.links-menu-extension.manifest.extension-title': 'Menu Liens [Nouveau]',
  'company-hub.links-menu-extension.manifest.first-default-item': 'À propos de nous',
  'company-hub.links-menu-extension.manifest.nested-default-item': 'Équipe 1',
  'company-hub.links-menu-extension.manifest.second-default-item': 'Avantages',
  'company-hub.links-menu-extension.manifest.third-default-item': 'Équipes',
  'company-hub.links-menu-extension.no.border.label-text': 'Aucune',
  'company-hub.links-menu-extension.right.option': 'À droite',
  'company-hub.links-menu-extension.section.collapse.label': 'Réduire la section',
  'company-hub.links-menu-extension.section.expand.label': 'Agrandir la section',
  'company-hub.links-menu-extension.selected.state.color': "Couleur de l'état sélectionné",
  'company-hub.links-menu-extension.text.color': 'Couleur du texte',
  'company-hub.links-menu-extension.text.title': 'Texte',
};
